module.exports = __webpack_public_path__ + "img/1.13.A.a9200258.png";